import type { CustomFile } from '../../types';

type ErrorMessageOptions = {
  extensionErrorMessage: string | null;
  fileSizeExceededErrorMessage: string | null;
  emptyFileErrorMessage: string | null;
  unexpectedErrorMessage: string | null;
};

export const getFileErrorText = (
  {
    extensionError,
    emptyFileError,
    fileSizeExceededError,
    uploadError
  }: CustomFile,
  {
    extensionErrorMessage,
    fileSizeExceededErrorMessage,
    emptyFileErrorMessage,
    unexpectedErrorMessage
  }: ErrorMessageOptions
) => {
  if (extensionError) {
    return extensionErrorMessage;
  }

  if (emptyFileError) {
    return emptyFileErrorMessage;
  }

  if (fileSizeExceededError) {
    return fileSizeExceededErrorMessage;
  }

  if (uploadError) {
    return unexpectedErrorMessage;
  }

  return null;
};
